import React from 'react';

import generateClassName from '../../../utils/generateClassName';
import ENUMS from '../../../enums';

import ReservesReportListTableRow from './TableRow';
import ShowForPermission from '../../../components/ShowForPermission';

import styles from './styles.scss';

const { VIEW_ARCHIVE_RESERVES_FOR_ADMIN } = ENUMS.PERMISSIONS.values;

function ReservesReportListTable(props) {
  const {
    sortedColumn,
    sortType,
    sortTable,
    itemsPerPage,
    currentPage,
    renderStatusColors,
    displayReserveDetailsModal,
    displayInvoiceModal
  } = props;

  return (
    <table className="table table-bordered table-striped">
      <thead>
        <tr>
          <th className="text-center">{locales('tables.row')}</th>
          <th onClick={() => sortTable('createdFullName')} className="text-center pointer">
            <i
              name="createdFullName"
              className={generateClassName('createdFullName', sortedColumn, sortType)}
            />
            {locales('tables.requestor')}
          </th>
          <th onClick={() => sortTable('startAt')} className="text-center pointer">
            <i name="startAt" className={generateClassName('startAt', sortedColumn, sortType)} />
            {locales('tables.reserveStartingTime')}
          </th>
          <th onClick={() => sortTable('endAt')} className="text-center pointer">
            <i name="endAt" className={generateClassName('endAt', sortedColumn, sortType)} />
            {locales('tables.reserveEndingTime')}
          </th>
          <th className="text-center">{locales('messages.tables')}</th>
          <th onClick={() => sortTable('reserveType')} className="text-center pointer">
            <i
              name="reserveType"
              className={generateClassName('reserveType', sortedColumn, sortType)}
            />
            {locales('tables.reservationType')}
          </th>
          <th onClick={() => sortTable('trackingNumber')} className="text-center pointer">
            <i
              name="trackingNumber"
              className={generateClassName('trackingNumber', sortedColumn, sortType)}
            />
            {locales('fields.trackingNumber')}
          </th>
          <th onClick={() => sortTable('persons')} className="text-center pointer">
            <i name="persons" className={generateClassName('persons', sortedColumn, sortType)} />
            {locales('tables.peopleCount')}
          </th>
          <th onClick={() => sortTable('meal')} className="text-center pointer">
            <i name="meal" className={generateClassName('meal', sortedColumn, sortType)} />
            {locales('tables.mealPortions')}
          </th>
          <th className="text-center">{locales('tables.status')}</th>
          <ShowForPermission permission={VIEW_ARCHIVE_RESERVES_FOR_ADMIN}>
            <th className="text-center">{locales('fields.cafe.name')}</th>
          </ShowForPermission>
          <th className="text-center" colSpan="2"></th>
        </tr>
      </thead>
      <tbody>
        {props.data && props.data.length ? (
          props.data.map((item, ix) => (
            <ReservesReportListTableRow
              key={item.id}
              ix={ix}
              itemsPerPage={itemsPerPage}
              currentPage={currentPage}
              id={item.id}
              isSuspended={item.isSuspended}
              createdFullName={item.createdFullName}
              createdAt={item.createdAt}
              startAt={item.startAt}
              endAt={item.endAt}
              reservedTables={item.reservedTables}
              reserveType={item.reserveType}
              trackingNumber={item.trackingNumber}
              persons={item.persons}
              meal={item.meal}
              status={item.status}
              cafeName={item.cafeName}

              renderStatusColors={renderStatusColors}
              displayReserveDetailsModal={displayReserveDetailsModal}
              // displayInvoiceModal={displayInvoiceModal}
            />
          ))
        ) : (
          <tr className="col-12 text-center">
            <td className="alert alert-info" colSpan={14}>
              {locales('alerts.noRecord')}
            </td>
          </tr>
        )}
      </tbody>
    </table>
  );
}

export default ReservesReportListTable;
